"use strict";
/*
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.POINT2 = void 0;
/**
 * Class to provide a Point object with a linestyle to facilitate drawing.
 *
 */
class POINT2 {
    x = 0;
    y = 0;
    style = 0;
    segment = 0;
    constructor(...args) {
        switch (args.length) {
            case 0: {
                this.x = 0;
                this.y = 0;
                this.style = 0;
                break;
            }
            case 1: {
                const [pt] = args;
                this.x = pt.x;
                this.y = pt.y;
                this.segment = pt.segment;
                this.style = pt.style;
                break;
            }
            case 2: {
                const [x, y] = args;
                this.x = x;
                this.y = y;
                this.style = 0;
                break;
            }
            case 3: {
                const [x, y, style] = args;
                this.x = x;
                this.y = y;
                this.style = style;
                break;
            }
            case 4: {
                const [x, y, segment, style] = args;
                this.x = x;
                this.y = y;
                this.segment = segment;
                this.style = style;
                break;
            }
            default: {
                throw Error(`Invalid number of arguments`);
            }
        }
    }
    getX() {
        return this.x;
    }
    getY() {
        return this.y;
    }
}
exports.POINT2 = POINT2;
//# sourceMappingURL=POINT2.js.map